export class CoordonneesUtil {
  static supprimerEspace(string: string): string {
    return string?.replace(/ /g, '');
  }

  static removeDoubleSpace(string: string): string {
    return string?.replace(/\s+/g, ' ');
  }
}
